var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#673bb6",
    strokeWidth: 1.5,
    d: "M14.5833 32.0833C21.0267 32.0833 26.25 26.86 26.25 20.4167C26.25 13.9733 21.0267 8.75 14.5833 8.75C8.14001 8.75 2.91667 13.9733 2.91667 20.4167C2.91667 26.86 8.14001 32.0833 14.5833 32.0833Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#673bb6",
    d: "M32.0833 2.91666H33.1771C33.1771 2.62658 33.0619 2.34838 32.8567 2.14326C32.6516 1.93814 32.3734 1.82291 32.0833 1.82291V2.91666ZM30.9896 10.2083C30.9896 10.4984 31.1048 10.7766 31.3099 10.9817C31.5151 11.1868 31.7933 11.3021 32.0833 11.3021C32.3734 11.3021 32.6516 11.1868 32.8567 10.9817C33.0619 10.7766 33.1771 10.4984 33.1771 10.2083H30.9896ZM24.7917 1.82291C24.5016 1.82291 24.2234 1.93814 24.0183 2.14326C23.8132 2.34838 23.6979 2.62658 23.6979 2.91666C23.6979 3.20674 23.8132 3.48494 24.0183 3.69005C24.2234 3.89517 24.5016 4.01041 24.7917 4.01041V1.82291ZM23.3771 13.1687L32.8563 3.68957L31.3104 2.14374L21.8313 11.6229L23.3771 13.1687ZM30.9896 2.91666V10.2083H33.1771V2.91666H30.9896ZM24.7917 4.01041H32.0833V1.82291H24.7917V4.01041Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMen);
export default __webpack_public_path__ + "static/media/men.fd865543a567a53d0b12ac019157d18f.svg";
export { ForwardRef as ReactComponent };